document.addEventListener('DOMContentLoaded', event => {    
    let hasAddedUnitChoice = false;
    let hasAddedThreadChoice = false;
    let hasAddedDiameterChoice = false;
    let hasAddedDiameterUnitChoice = false;
    let hasAddedSurfaceChoice = false;
    let chosen_unit = 'in';
    let chosen_thread = 'NPT';
    let chosen_diameter = 'ID';
    let chosen_diameterunit = 'in';
    let chosen_surface = 'Smooth';
    var cts_app = document.querySelectorAll('html')[0]._x_dataStack[0];
    const mobile = window.matchMedia("(max-width: 768px)");

    // PO Number / Cart Attributes support
    window.updateCartAttribute = async function(name, value) {
        if (!cts_app) return;
        cts_app.cart_loading = true;
        try {
            const response = await fetch(
                `${window.Shopify.routes.root}cart/update.js`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { [name]: value } })
                }
            );
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.description || 'Failed to update cart attribute');
            }
        } catch (error) {
            console.error('Error updating cart attribute:', error);
        } finally {
            cts_app.cart_loading = false;
        }
    };

    // Refresh cart on pageshow (back / forward) fix for Edge and mobile
    window.addEventListener('pageshow', (e) => {
        // Edge and mobile
        if (cts_app && !mobile.matches) {
            cts_app.updateCart(false);            
        }
    });

    document.addEventListener('Searchanise.Loaded', function(event, input, container) {
        
        (function ($) {         
            /* Replaces description with specs meta value if specs exists */
            $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
                // console.log('datarequestend',data);
                data.items.forEach((d)=>d.description = d.metafield_890876f17d8f280fff23283fe46f6524?.split('|').join('<br>') || d.description);
            });        

            $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
                cts_app.updateCart(true);
            });            
            
            let seal_range_filter_in, seal_range_filter_mm, has_seal_range_filter;

            let id_seal_in, id_seal_mm, has_id, od_seal_in, od_seal_mm, has_od;

            let thread_NPT, thread_SAE, thread_M, has_thread;

            function showUnitSelection(e) {
                if(e.target.value == "in"){
                    seal_range_filter_in?.style.setProperty('display', 'block', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_in_mobile?.style.setProperty('display', 'block', 'important');
                    seal_range_filter_mm_mobile?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_in_mobile2?.style.setProperty('display', 'block', 'important');
                    seal_range_filter_mm_mobile2?.style.setProperty('display', 'none', 'important');
                    chosen_unit = 'in';

                    thread_NPT?.style.setProperty('display', 'none', 'important');
                    thread_SAE?.style.setProperty('display', 'none', 'important');
                    thread_M?.style.setProperty('display', 'none', 'important');
                } else {
                    seal_range_filter_in?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'block', 'important');
                    seal_range_filter_in_mobile?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm_mobile?.style.setProperty('display', 'block', 'important');
                    seal_range_filter_in_mobile2?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm_mobile2?.style.setProperty('display', 'block', 'important');
                    chosen_unit = 'mm';

                    thread_NPT?.style.setProperty('display', 'none', 'important');
                    thread_SAE?.style.setProperty('display', 'none', 'important');
                    thread_M?.style.setProperty('display', 'none', 'important');
                }
            }

            function showSurfaceSelection(e) {
                const surfaceSelects = document.querySelectorAll('.sg_select_surface');
                const unitSelects    = document.querySelectorAll('.sg_select_unit');
                const threadSelects  = document.querySelectorAll('.sg_select_thread');

                const pickActive = (list) =>
                    [...list].find(sel => sel.offsetParent !== null) || list[0];

                const surface = pickActive(surfaceSelects)?.value || chosen_surface;
                const unit    = pickActive(unitSelects)?.value    || chosen_unit;
                const thread  = pickActive(threadSelects)?.value  || chosen_thread;

                chosen_surface = surface;
                chosen_unit    = unit;
                chosen_thread  = thread;

                surfaceSelects.forEach(sel => { if (sel.value !== surface) sel.value = surface; });

                const toggle = (el, show) =>
                    el?.style.setProperty('display', show ? 'block' : 'none', 'important');

                // Show/hide the DROPDOWN WRAPPERS based on surface choice
                // (when Smooth, show the unit dropdown; when Threaded, show the thread dropdown)
                unitSelects.forEach(sel => toggle(sel.closest('.snize-product-filters-block'), surface == 'Smooth'));
                threadSelects.forEach(sel => toggle(sel.closest('.snize-product-filters-block'), surface == 'Threaded'));

                // Smooth → show only the matching unit range facets
                toggle(seal_range_filter_in,         surface == 'Smooth' && unit == 'in');
                toggle(seal_range_filter_in_mobile,  surface == 'Smooth' && unit == 'in');
                toggle(seal_range_filter_in_mobile2, surface == 'Smooth' && unit == 'in');
                toggle(seal_range_filter_mm,         surface == 'Smooth' && unit == 'mm');
                toggle(seal_range_filter_mm_mobile,  surface == 'Smooth' && unit == 'mm');
                toggle(seal_range_filter_mm_mobile2, surface == 'Smooth' && unit == 'mm');

                // Threaded → show only the matching thread facets
                toggle(thread_NPT,         surface == 'Threaded' && thread == 'NPT');
                toggle(thread_NPT_mobile,  surface == 'Threaded' && thread == 'NPT');
                toggle(thread_NPT_mobile2, surface == 'Threaded' && thread == 'NPT');
                toggle(thread_SAE,         surface == 'Threaded' && thread == 'SAE');
                toggle(thread_SAE_mobile,  surface == 'Threaded' && thread == 'SAE');
                toggle(thread_SAE_mobile2, surface == 'Threaded' && thread == 'SAE');
                toggle(thread_M,           surface == 'Threaded' && thread == 'M');
                toggle(thread_M_mobile,    surface == 'Threaded' && thread == 'M');
                toggle(thread_M_mobile2,   surface == 'Threaded' && thread == 'M');
            }

            function updateDiameterDisplay() {
                const diameterSelects = document.querySelectorAll('.sg_select_diameter');
                const unitSelects = document.querySelectorAll('.sg_select_diameterunit');

                const activeDiameter = [...diameterSelects].find(sel => sel.offsetParent !== null) || diameterSelects[0];
                const activeUnit = [...unitSelects].find(sel => sel.offsetParent !== null) || unitSelects[0];

                const diameter = activeDiameter?.value || chosen_diameter;
                const unit = activeUnit?.value || chosen_diameterunit;

                chosen_diameter = diameter;
                chosen_diameterunit = unit;

                diameterSelects.forEach(sel => { if (sel.value !== diameter) sel.value = diameter; });
                unitSelects.forEach(sel => { if (sel.value !== unit) sel.value = unit; });

                const toggle = (el, show) => el?.style.setProperty('display', show ? 'block' : 'none', 'important');

                // Desktop
                toggle(id_seal_in, diameter == 'ID' && unit == 'in');
                toggle(id_seal_mm, diameter == 'ID' && unit == 'mm');
                toggle(od_seal_in, diameter == 'OD' && unit == 'in');
                toggle(od_seal_mm, diameter == 'OD' && unit == 'mm');

                // Mobile (header variant)
                toggle(id_seal_in_mobile, diameter == 'ID' && unit == 'in');
                toggle(id_seal_mm_mobile, diameter == 'ID' && unit == 'mm');
                toggle(od_seal_in_mobile, diameter == 'OD' && unit == 'in');
                toggle(od_seal_mm_mobile, diameter == 'OD' && unit == 'mm');

                // Mobile (body variant) ← this is what was missing
                toggle(id_seal_in_mobile2, diameter == 'ID' && unit == 'in');
                toggle(id_seal_mm_mobile2, diameter == 'ID' && unit == 'mm');
                toggle(od_seal_in_mobile2, diameter == 'OD' && unit == 'in');
                toggle(od_seal_mm_mobile2, diameter == 'OD' && unit == 'mm');
            }

            function showDiameterSelection(e) { updateDiameterDisplay(); }
            function showDiameterUnitSelection(e) { updateDiameterDisplay(); }


            function showThreadSelection(e) {
                if(e.target.value == "NPT"){
                    thread_NPT?.style.setProperty('display', 'block', 'important');
                    thread_NPT_mobile?.style.setProperty('display', 'block', 'important');
                    thread_NPT_mobile2?.style.setProperty('display', 'block', 'important');
                    thread_SAE?.style.setProperty('display', 'none', 'important');
                    thread_SAE_mobile?.style.setProperty('display', 'none', 'important');
                    thread_SAE_mobile2?.style.setProperty('display', 'none', 'important');
                    thread_M?.style.setProperty('display', 'none', 'important');
                    thread_M_mobile?.style.setProperty('display', 'none', 'important');
                    thread_M_mobile2?.style.setProperty('display', 'none', 'important');
                    chosen_thread = 'NPT';

                    seal_range_filter_in?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'none', 'important');
                } 
                else if(e.target.value == "SAE"){
                    thread_NPT?.style.setProperty('display', 'none', 'important');
                    thread_NPT_mobile?.style.setProperty('display', 'none', 'important');
                    thread_NPT_mobile2?.style.setProperty('display', 'none', 'important');
                    thread_SAE?.style.setProperty('display', 'block', 'important');
                    thread_SAE_mobile?.style.setProperty('display', 'block', 'important');
                    thread_SAE_mobile2?.style.setProperty('display', 'block', 'important');
                    thread_M?.style.setProperty('display', 'none', 'important');
                    thread_M_mobile?.style.setProperty('display', 'none', 'important');
                    thread_M_mobile2?.style.setProperty('display', 'none', 'important');
                    chosen_thread = 'SAE';

                    seal_range_filter_in?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'none', 'important');
                } 
                else {
                    thread_NPT?.style.setProperty('display', 'none', 'important');
                    thread_NPT_mobile?.style.setProperty('display', 'none', 'important');
                    thread_NPT_mobile2?.style.setProperty('display', 'none', 'important');
                    thread_SAE?.style.setProperty('display', 'none', 'important');
                    thread_SAE_mobile?.style.setProperty('display', 'none', 'important');
                    thread_SAE_mobile2?.style.setProperty('display', 'none', 'important');
                    thread_M?.style.setProperty('display', 'block', 'important');
                    thread_M_mobile?.style.setProperty('display', 'block', 'important');
                    thread_M_mobile2?.style.setProperty('display', 'block', 'important');
                    chosen_thread = 'M';

                    seal_range_filter_in?.style.setProperty('display', 'none', 'important');
                    seal_range_filter_mm?.style.setProperty('display', 'none', 'important');
                }
            }
            
            // Fires after the Search Results widget (incl. filters sidebar) finishes rendering
            $(document).on('Searchanise.ResultsUpdated', function (event, $container) {

                // Mobile
                // snize_product_filter_header_filter_metafield_5ca16f433209745ce003384917821ad9
                // snize_product_filter_filter_metafield_5ca16f433209745ce003384917821ad9
                // snize_product_filter_header_filter_metafield_7f9152f33fb92b8018fa5176778cd10b
                // snize_product_filter_filter_metafield_7f9152f33fb92b8018fa5176778cd10b

                seal_range_filter_in = document.querySelector('#snize_filters_block_filter_metafield_5ca16f433209745ce003384917821ad9');                
                seal_range_filter_mm = document.querySelector('#snize_filters_block_filter_metafield_7f9152f33fb92b8018fa5176778cd10b');
                seal_range_filter_in_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_5ca16f433209745ce003384917821ad9');                
                seal_range_filter_mm_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_7f9152f33fb92b8018fa5176778cd10b');
                seal_range_filter_in_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_5ca16f433209745ce003384917821ad9');                
                seal_range_filter_mm_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_7f9152f33fb92b8018fa5176778cd10b');

                id_seal_in = document.querySelector('#snize_filters_block_snize_facet4');
                id_seal_mm = document.querySelector('#snize_filters_block_snize_facet3');
                id_seal_in_mobile = document.querySelector('#snize_product_filter_header_snize_facet4');
                id_seal_mm_mobile = document.querySelector('#snize_product_filter_header_snize_facet3');
                od_seal_in = document.querySelector('#snize_filters_block_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                od_seal_mm = document.querySelector('#snize_filters_block_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');
                od_seal_in_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                od_seal_mm_mobile = document.querySelector('#snize_product_filter_header_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');
                id_seal_in_mobile2 = document.querySelector('#snize_product_filter_snize_facet4');
                id_seal_mm_mobile2 = document.querySelector('#snize_product_filter_snize_facet3');
                od_seal_in_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_4900c1b0fd9c019957f152a6f79e625d');
                od_seal_mm_mobile2 = document.querySelector('#snize_product_filter_filter_metafield_6ee58cd8dcce1957900f3a5dd792c0da');

                has_seal_range_filter = seal_range_filter_in && seal_range_filter_mm;
                has_seal_range_filter_mobile = seal_range_filter_in_mobile && seal_range_filter_mm_mobile;

                has_id_od = id_seal_in && id_seal_mm && od_seal_in && od_seal_mm;
                has_id_od_mobile = id_seal_in_mobile && id_seal_mm_mobile && od_seal_in_mobile && od_seal_mm_mobile;
                has_od = od_seal_in && od_seal_mm;
                has_od_mobile = od_seal_in_mobile && od_seal_mm_mobile;

                thread_NPT = document.querySelector('#snize_filters_block_snize_facet9');
                thread_NPT_mobile = document.querySelector('#snize_product_filter_header_snize_facet9');
                thread_NPT_mobile2 = document.querySelector('#snize_product_filter_snize_facet9');
                thread_SAE = document.querySelector('#snize_filters_block_snize_facet6');
                thread_SAE_mobile = document.querySelector('#snize_product_filter_header_snize_facet6');
                thread_SAE_mobile2 = document.querySelector('#snize_product_filter_snize_facet6');
                thread_M = document.querySelector('#snize_filters_block_snize_facet8');
                thread_M_mobile = document.querySelector('#snize_product_filter_header_snize_facet8');
                thread_M_mobile2 = document.querySelector('#snize_product_filter_snize_facet8');

                body_style = document.querySelector('#snize_filters_block_snize_facet5');
                body_style_mobile = document.querySelector('#snize_product_filter_header_snize_facet5');

                has_thread = thread_NPT || thread_SAE || thread_M;
                has_thread_mobile = thread_NPT_mobile || thread_SAE_mobile || thread_M_mobile;

                has_thread_and_range = has_thread && has_seal_range_filter;
                has_thread_and_range_mobile = has_thread_mobile && has_seal_range_filter_mobile;

                if ((has_seal_range_filter || has_seal_range_filter_mobile)) {
                    const filterSidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');
                    const mobileModalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');

                    const addUnitSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-units-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-units-selector">
                                <label for="sg_select_unit_${idSuffix}" class="cts-units-selector-label">Select a Sealing Range Unit:</label>
                                <select name="sg_select_unit" id="sg_select_unit_${idSuffix}" class="sg_select_unit">
                                    <option value="in" ${chosen_unit == 'in' ? 'selected' : ''}>Inches</option>
                                    <option value="mm" ${chosen_unit == 'mm' ? 'selected' : ''}>Millimeters</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showUnitSelection;
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedUnitChoice = true;
                    };

                    addUnitSelector(filterSidebar, 'desktop', seal_range_filter_in);
                    addUnitSelector(mobileModalContent, 'mobile', seal_range_filter_in_mobile);

                    // Sync all selects to chosen_unit, then dispatch on the visible one (or fall back to the first)
                    const allSelects = document.querySelectorAll('.sg_select_unit');
                    allSelects.forEach(sel => sel.value = chosen_unit);

                    const activeSelect = [...allSelects].find(sel => sel.offsetParent !== null) || allSelects[0];
                    if (activeSelect?.value) {
                        activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }

                if (has_id_od || has_id_od_mobile) {
                    const filterSidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');
                    const mobileModalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');

                    const addDiameterSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-diameter-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-diameter-selector">
                                <label for="sg_select_diameter_${idSuffix}" class="cts-diameter-selector-label">Select ID or OD Surface:</label>
                                <select name="sg_select_diameter" id="sg_select_diameter_${idSuffix}" class="sg_select_diameter">
                                    <option value="ID" ${chosen_diameter == 'ID' ? 'selected' : ''}>Inside Diameter</option>
                                    <option value="OD" ${chosen_diameter == 'OD' ? 'selected' : ''}>Outside Diameter</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showDiameterSelection;
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedDiameterChoice = true;
                    };

                    const addDiameterUnitSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-diameterunit-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-diameterunit-selector">
                                <label for="sg_select_diameterunit_${idSuffix}" class="cts-diameterunit-selector-label">Select a Sealing Range Unit:</label>
                                <select name="sg_select_diameterunit" id="sg_select_diameterunit_${idSuffix}" class="sg_select_diameterunit">
                                    <option value="in" ${chosen_diameterunit == 'in' ? 'selected' : ''}>Inches</option>
                                    <option value="mm" ${chosen_diameterunit == 'mm' ? 'selected' : ''}>Millimeters</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showDiameterUnitSelection;
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedDiameterUnitChoice = true;
                    };

                    addDiameterSelector(filterSidebar, 'desktop', id_seal_in);
                    addDiameterSelector(mobileModalContent, 'mobile', id_seal_in_mobile);
                    addDiameterUnitSelector(filterSidebar, 'desktop', id_seal_in);
                    addDiameterUnitSelector(mobileModalContent, 'mobile', id_seal_in_mobile);

                    // Sync all selects to their chosen values, then dispatch on the visible one (or fall back to the first)
                    for (const [cls, value] of [['sg_select_diameter', chosen_diameter], ['sg_select_diameterunit', chosen_diameterunit]]) {
                        const selects = document.querySelectorAll(`.${cls}`);
                        selects.forEach(sel => sel.value = value);
                        const active = [...selects].find(sel => sel.offsetParent !== null) || selects[0];
                        if (active?.value) active.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                
                if (has_thread || has_thread_mobile) {
                    const filterSidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');
                    const mobileModalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');

                    const addThreadSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-thread-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-thread-selector">
                                <label for="sg_select_thread_${idSuffix}" class="cts-thread-selector-label">Select a Thread Type:</label>
                                <select name="sg_select_thread" id="sg_select_thread_${idSuffix}" class="sg_select_thread">
                                    <option value="NPT" ${chosen_thread == 'NPT' ? 'selected' : ''}>NPT</option>
                                    <option value="SAE" ${chosen_thread == 'SAE' ? 'selected' : ''}>SAE</option>
                                    <option value="M" ${chosen_thread == 'M' ? 'selected' : ''}>M</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showThreadSelection;
                        container.insertBefore(wrapper, insertBefore);
                        hasAddedThreadChoice = true;
                    };

                    const referenceNode = thread_NPT || thread_SAE || thread_M;
                    const referenceNode_mobile = thread_NPT_mobile || thread_SAE_mobile || thread_M_mobile;

                    addThreadSelector(filterSidebar, 'desktop', referenceNode);
                    addThreadSelector(mobileModalContent, 'mobile', referenceNode_mobile);

                    const allSelects = document.querySelectorAll('.sg_select_thread');
                    allSelects.forEach(sel => sel.value = chosen_thread);

                    const activeSelect = [...allSelects].find(sel => sel.offsetParent !== null) || allSelects[0];
                    if (activeSelect?.value) {
                        activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }

                if ((has_thread_and_range || has_thread_and_range_mobile) && !body_style) {
                    const filterSidebar      = document.querySelector('.snize-filters-sidebar.snize-product-filters');
                    const mobileModalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');

                    const addSurfaceSelector = (container, idSuffix, insertBefore) => {
                        if (!container || container.querySelector('.cts-surface-selector')) return;

                        const wrapper = document.createElement('div');
                        wrapper.classList.add('snize-product-filters-block');
                        wrapper.innerHTML = `
                            <div style="display:inline-block;" class="snize-product-filters-title cts-surface-selector">
                                <label for="sg_select_surface_${idSuffix}" class="cts-surface-selector-label">Select a Surface Type:</label>
                                <select name="sg_select_surface" id="sg_select_surface_${idSuffix}" class="sg_select_surface">
                                    <option value="Smooth"   ${chosen_surface == 'Smooth'   ? 'selected' : ''}>Smooth</option>
                                    <option value="Threaded" ${chosen_surface == 'Threaded' ? 'selected' : ''}>Threaded</option>
                                </select>
                            </div>`;
                        wrapper.querySelector('select').onchange = showSurfaceSelection;

                        // Only use insertBefore if the ref actually lives in this container
                        if (insertBefore && container.contains(insertBefore)) {
                            container.insertBefore(wrapper, insertBefore);
                        } else {
                            container.prepend(wrapper);
                        }
                        hasAddedSurfaceChoice = true;
                    };

                    // Find a reference INSIDE each container — important: don't share refs across containers
                    const desktopUnitBlock = document.querySelector('#sg_select_unit_desktop')?.closest('.snize-product-filters-block');
                    const mobileUnitBlock  = document.querySelector('#sg_select_unit_mobile')?.closest('.snize-product-filters-block');

                    const surfaceRefDesktop = desktopUnitBlock || seal_range_filter_in || seal_range_filter_mm || thread_NPT || thread_SAE || thread_M;
                    const surfaceRefMobile  = mobileUnitBlock  || seal_range_filter_in_mobile || seal_range_filter_mm_mobile || seal_range_filter_in_mobile2 || seal_range_filter_mm_mobile2 || thread_NPT_mobile || thread_SAE_mobile || thread_M_mobile;

                    addSurfaceSelector(filterSidebar, 'desktop', surfaceRefDesktop);
                    addSurfaceSelector(mobileModalContent, 'mobile',  surfaceRefMobile);

                    // Sync all surface selects, then trigger the visible one
                    const allSelects = document.querySelectorAll('.sg_select_surface');
                    allSelects.forEach(sel => sel.value = chosen_surface);

                    const activeSelect = [...allSelects].find(sel => sel.offsetParent !== null) || allSelects[0];
                    if (activeSelect?.value) {
                        activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }

                
            });
        })(window.Searchanise.$);
    });
});
//var app = document.querySelectorAll('html')[0]._x_dataStack[0];
